import script from "./accordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./accordion.vue?vue&type=script&setup=true&lang=ts"

import "./accordion.vue?vue&type=style&index=0&id=62cd1b38&scoped=true&lang=css"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62cd1b38"]])

export default __exports__